import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-4 w-full items-center justify-between" }
const _hoisted_2 = { class: "flex flex-col w-full gap-4" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", { class: "flex text-sm font-semibold pb-1" }, " Estado ", -1)
const _hoisted_4 = { class: "flex flex-row gap-6 mx-[2%]" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { for: "payed" }, "Pagado", -1)
const _hoisted_6 = { class: "flex flex-row gap-6 mx-[2%]" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { for: "pending" }, "Pendiente", -1)
const _hoisted_8 = { class: "flex flex-row gap-6 mx-[2%]" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { for: "pending" }, "Rechazado", -1)
const _hoisted_10 = { class: "w-full" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelectorHtmlBased = _resolveComponent("SelectorHtmlBased")!
  const _component_Datepicker = _resolveComponent("Datepicker")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("form", _hoisted_2, [
      _createVNode(_component_SelectorHtmlBased, {
        items: _ctx.shareholderItems,
        model: _ctx.shareholderSelected,
        "onUpdate:model": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.shareholderSelected) = $event)),
        label: 'Accionista',
        values: _ctx.shareholderValues
      }, null, 8, ["items", "model", "values"]),
      _hoisted_3,
      _createElementVNode("section", _hoisted_4, [
        _withDirectives(_createElementVNode("input", {
          id: "payed",
          type: "checkbox",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.dividendsFilter.showPayed) = $event))
        }, null, 512), [
          [_vModelCheckbox, _ctx.dividendsFilter.showPayed]
        ]),
        _hoisted_5
      ]),
      _createElementVNode("section", _hoisted_6, [
        _withDirectives(_createElementVNode("input", {
          id: "pending",
          type: "checkbox",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.dividendsFilter.showPending) = $event))
        }, null, 512), [
          [_vModelCheckbox, _ctx.dividendsFilter.showPending]
        ]),
        _hoisted_7
      ]),
      _createElementVNode("section", _hoisted_8, [
        _withDirectives(_createElementVNode("input", {
          id: "pending",
          type: "checkbox",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.dividendsFilter.showRejected) = $event))
        }, null, 512), [
          [_vModelCheckbox, _ctx.dividendsFilter.showRejected]
        ]),
        _hoisted_9
      ]),
      _createVNode(_component_Datepicker, {
        modelValue: _ctx.dividendsFilter.filterDate,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.dividendsFilter.filterDate) = $event)),
        "enable-time-picker": false,
        cancelText: 'Cancelar',
        selectText: 'Seleccionar'
      }, null, 8, ["modelValue"])
    ]),
    _createElementVNode("footer", _hoisted_10, [
      _createElementVNode("button", {
        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.submitHandler && _ctx.submitHandler(...args))),
        class: "btn w-full"
      }, "Filtrar")
    ])
  ]))
}